<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.clientCabinet.headerTitle')" />

    <div class="base-container-first client__wrapper">
      <ul class="client__cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="client__cards">
        <li
          v-for="(advantage, advantageIndex) in ADVANTAGES"
          :key="advantageIndex"
        >
          <SharedPageCard
            isWhite
            :card="advantage"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.clientCabinet.managerDescription')"
    :title="t('pages.features.clientCabinet.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.clientCabinet.cards.quickRegistration.description"),
    image: "client-card-1",
    title: t("pages.features.clientCabinet.cards.quickRegistration.title"),
  },
  {
    description: t("pages.features.clientCabinet.cards.orderHistory.description"),
    image: "client-card-2",
    title: t("pages.features.clientCabinet.cards.orderHistory.title"),
  },
]);

const BUSINESSES = computed(() => [
  t("pages.features.clientCabinet.businesses.beautySalon"),
  t("pages.features.clientCabinet.businesses.clothingStore"),
  t("pages.features.clientCabinet.businesses.lawyer"),
  t("pages.features.clientCabinet.businesses.barbershop"),
  t("pages.features.clientCabinet.businesses.carWash"),
  t("pages.features.clientCabinet.businesses.fitness"),
  t("pages.features.clientCabinet.businesses.notary"),
  t("pages.features.clientCabinet.businesses.photoStudio"),
  t("pages.features.clientCabinet.businesses.billiardRoom"),
  t("pages.features.clientCabinet.businesses.yourBusiness"),
]);

const ADVANTAGES = computed(() => [
  {
    description: t("pages.features.clientCabinet.cards.personalDiscounts.description"),
    image: "client-card-3",
    title: t("pages.features.clientCabinet.cards.personalDiscounts.title"),
  },
  {
    description: t("pages.features.clientCabinet.cards.notifications.description"),
    image: "client-card-4",
    title: t("pages.features.clientCabinet.cards.notifications.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.clientCabinet.seo.title"),
});
</script>

<style scoped>
.client__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .client__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.client__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .client__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}
</style>
